import { gql } from '@apollo/client';

export const CREATE_STYLING_SESSION_OUTCOME = gql`
    mutation CreateStylingSessionOutcome($input: CreateStylingSessionOutcomeInput!) {
        createStylingSessionOutcome(input: $input) {
            id
            sessionTaffiId
            type
            styleId
            itemId
            styleGuideId
        }
    }
`;

export const DELETE_STYLING_SESSION_OUTCOME = gql`
    mutation DeleteStylingSessionOutcome($input: DeleteStylingSessionOutcomeInput!) {
        deleteStylingSessionOutcome(input: $input) {
            id
            sessionTaffiId
        }
    }
`;
